import React from 'react'
import Dream_1 from '../../../assets/images/home_page_4/about/03.png'

const Dream = () => {
    return (
        <>
            <section id="dreams-section" className="dreams-main-block">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="about-us-img">
                                <img
                                    src={Dream_1}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="about-us-block">
                                <h6 className="about-sub-heading hr-lines">Lawpro Solutions</h6>
                                <h1 className="about-main-heading">
                                    Building Dreams, Crafting Realities
                                </h1>
                                <p>
                                    Our mission is there are many variations of passages of Lorem Ipsum
                                    available, but the majority have suffered alteration Our mission is
                                    there are many variations of passages of Lorem Ipsum available, but
                                    the majority have suffered alteration{" "}
                                </p>
                                <ul className="about-list-block">
                                    <li>
                                        <i className="flaticon-check-mark" />
                                        The power of applied intelligence
                                    </li>
                                    <li>
                                        <i className="flaticon-check-mark" />
                                        We take a closer look
                                    </li>
                                    <li>
                                        <i className="flaticon-check-mark" />
                                        The power of applied intelligence
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Dream
